<div class="detail-group">
  <label *ngIf="showLabelText" [innerText]="renderLabelText"></label>
  <div *ngIf="!displayHTML" class="detail-text" [innerText]="value"></div>
  <div *ngIf="displayHTML" class="detail-text" [innerHTML]="value"></div>
</div>
